import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms'

@Injectable()
export class CambioPswValidators {

    static newIsNotOld(group: FormGroup){
        var newPassword = group.controls['newPwd'];
        if(newPassword != undefined && group.controls['currentPwd'].value == newPassword.value)
        newPassword.setErrors({ newIsNotOld: true });
        return null;
    }

    static newMatchesConfirm(group: FormGroup){
        var confirm = group.controls['confirmPwd'];
        if(confirm != undefined && group.controls['newPwd'].value !== confirm.value)
            confirm.setErrors({ newMatchesConfirm: true });
        return null;
    }
}
